/** Zeiten in der Zeitzone der Installation (Konzept, Sprache und Formate). */

/** Geschütztes Leerzeichen zwischen Zahl und Einheit */
export const NB = '\u00a0';

const ZEITZONE = 'Europe/Vienna';

const datumZeit = new Intl.DateTimeFormat('de-AT', { dateStyle: 'medium', timeStyle: 'short', timeZone: ZEITZONE });
const nurDatum = new Intl.DateTimeFormat('de-AT', { dateStyle: 'medium', timeZone: ZEITZONE });
const nurZeit = new Intl.DateTimeFormat('de-AT', { hour: '2-digit', minute: '2-digit', timeZone: ZEITZONE });
const zahl = new Intl.NumberFormat('de-AT', { maximumFractionDigits: 1 });

export function formatiereZeitpunkt(iso: string | number | Date): string {
  return datumZeit.format(new Date(iso));
}

/** Datum ohne Uhrzeit, etwa für Prüfdatum und Fälligkeit */
export function formatiereDatum(iso: string | number | Date): string {
  return nurDatum.format(new Date(iso));
}

export function formatiereUhrzeit(iso: string | number | Date): string {
  return nurZeit.format(new Date(iso));
}

export function formatiereZahl(wert: number): string {
  return zahl.format(wert);
}

export const TAG_MS = 24 * 60 * 60 * 1000;

/** „vor 3 Tagen“, „vor 5 Minuten“ */
export function vorWieLange(iso: string | number, jetzt = Date.now()): string {
  const ms = Math.max(0, jetzt - new Date(iso).getTime());
  const min = Math.round(ms / 60_000);
  if (min < 1) return 'gerade eben';
  if (min < 60) return min === 1 ? `vor 1${NB}Minute` : `vor ${min}${NB}Minuten`;
  const std = Math.round(min / 60);
  if (std < 36) return std === 1 ? `vor 1${NB}Stunde` : `vor ${std}${NB}Stunden`;
  const tage = Math.round(ms / TAG_MS);
  return tage === 1 ? `vor 1${NB}Tag` : `vor ${tage}${NB}Tagen`;
}

export function dauerText(ms: number): string {
  const tage = ms / TAG_MS;
  if (tage >= 1) return `${formatiereZahl(Math.floor(tage * 10) / 10)}${NB}Tagen`;
  const std = ms / 3_600_000;
  if (std >= 1) return `${formatiereZahl(Math.floor(std * 10) / 10)}${NB}Stunden`;
  return `${Math.max(1, Math.round(ms / 60_000))}${NB}Minuten`;
}

export function groesseText(bytes: number): string {
  if (bytes >= 1024 ** 3) return `${formatiereZahl(bytes / 1024 ** 3)}${NB}GB`;
  if (bytes >= 1024 ** 2) return `${formatiereZahl(bytes / 1024 ** 2)}${NB}MB`;
  return `${formatiereZahl(bytes / 1024)}${NB}KB`;
}
